import { Button, Card, FloatButton, Text } from '@/components';
import { BugOutlined } from '@ant-design/icons';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DebugModeModal } from './DebugModeModal';
import { FavoriteBusinessModal } from './FavoriteBusinessModal';
import { FeatureFlagsModal } from './FeatureFlagsModal';
import { LocalStorageDeleteModal } from './LocalStorageDeleteModal';
import { RolePermissionModal } from './RolePermissionModal';
import { TargetEnvBannerModal } from './TargetEnvBannerModal';

type ListKeyType =
  | 'feature-flags'
  | 'role-permission'
  | 'hidden-dev-tools'
  | 'debug-mode'
  | 'favorite'
  | 'localstorage-delete'
  | 'target-env-banner';

export const DevTools = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [modalType, setModalType] = useState<null | ListKeyType>(null);

  const list = useMemo<{ key: ListKeyType; text: string }[]>(
    () => [
      { key: 'feature-flags', text: t('dev-tools.feature-flags-label') },
      { key: 'role-permission', text: t('dev-tools.role-permission-label') },
      { key: 'debug-mode', text: t('dev-tools.debug-mode') },
      { key: 'favorite', text: t('dev-tools.favorite-label') },
      {
        key: 'target-env-banner',
        text: t('dev-tools.target-env-banner-label'),
      },
      {
        key: 'localstorage-delete',
        text: t('dev-tools.localstorage-delete-label'),
      },
      { key: 'hidden-dev-tools', text: t('dev-tools.hidden') },
    ],
    [t],
  );

  const handleCloseModal = () => {
    setModalType(null);
  };

  const handleClickList = (key: ListKeyType) => {
    switch (key) {
      case 'feature-flags':
        setModalType(key);
        break;

      case 'hidden-dev-tools':
        setHidden(true);
        break;

      case 'role-permission':
        setModalType(key);
        break;

      case 'debug-mode':
        setModalType(key);
        break;
      case 'favorite':
        setModalType(key);
        break;
      case 'localstorage-delete':
        setModalType(key);
        break;
      case 'target-env-banner':
        setModalType(key);
        break;
      default: {
        const check: never = key;
        throw new Error(`Unexpected target: ${check}`);
      }
    }
  };

  return hidden ? null : (
    <>
      <FloatButton.Group
        open={isOpen}
        onOpenChange={setIsOpen}
        trigger="click"
        icon={<BugOutlined />}
      >
        <Card
          bordered={false}
          hoverable
          style={{ marginLeft: -200 }}
          styles={{
            body: {
              padding: 8,
            },
          }}
        >
          {list.map(({ key, text }) => (
            <Button
              key={key}
              type="text"
              style={{ width: '100%', justifyContent: 'flex-start' }}
              onClick={() => {
                setIsOpen(false);
                handleClickList(key);
              }}
            >
              <Text text={text} variant="footnote" />
            </Button>
          ))}
        </Card>
      </FloatButton.Group>

      <FeatureFlagsModal
        isOpen={modalType === 'feature-flags'}
        onClose={handleCloseModal}
      />
      <RolePermissionModal
        isOpen={modalType === 'role-permission'}
        onClose={handleCloseModal}
      />
      <DebugModeModal
        isOpen={modalType === 'debug-mode'}
        onClose={handleCloseModal}
      />
      <FavoriteBusinessModal
        isOpen={modalType === 'favorite'}
        onClose={handleCloseModal}
      />
      <LocalStorageDeleteModal
        isOpen={modalType === 'localstorage-delete'}
        onClose={handleCloseModal}
      />
      <TargetEnvBannerModal
        isOpen={modalType === 'target-env-banner'}
        onClose={handleCloseModal}
      />
    </>
  );
};
